import { AccordionField } from '@components/DrawerAccordion';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';

import { isTemplatePlaceholder, RosterCriteria, TemplatePlaceholder } from '@/types';
import TemplateCapableSelect from '@pages/AdvancedSearchListCreatorPage/customWidgets/templateCapableComponents/TemplateCapableSelectV2';

type RosterCriteriaProps = {
  value: RosterCriteria;
  onChange: (newValue: RosterCriteria, field: keyof RosterCriteria) => void;
  isOnTemplatePage: boolean;
};

const RosterCriteriaForm = ({
  value = { votingPeriod: 'Any', shiftStatus: 'Confirmed' },
  onChange,
  isOnTemplatePage,
}: RosterCriteriaProps) => {
  const handleChange = (selectValue: string | TemplatePlaceholder, field: keyof RosterCriteria) => {
    const newValue = { ...value };

    if (selectValue === '') {
      delete newValue[field];
    } else {
      newValue[field] = selectValue;
    }

    onChange(newValue, 'votingPeriod');
  };

  return (
    <>
      <AccordionField title="Voting Period" inputId="rostercriteria-votingPeriod">
        <FormControl fullWidth focused={isTemplatePlaceholder(value.votingPeriod)}>
          <TemplateCapableSelect
            value={value.votingPeriod ?? ''}
            onChange={(v) => handleChange(v, 'votingPeriod')}
            isOnTemplatePage={isOnTemplatePage}
            valueAfterRemovePlaceholder="Any"
            templateBuilderDisplayName="Roster filter: Voting period"
          >
            <MenuItem value={'Any'}>Any</MenuItem>
            <MenuItem value={'Early voting'}>Early voting</MenuItem>
            <MenuItem value={'Polling Day'}>Polling Day</MenuItem>
          </TemplateCapableSelect>
        </FormControl>
      </AccordionField>

      <AccordionField title="Shift Status" inputId="rostercriteria-shiftStatus">
        <FormControl fullWidth focused={isTemplatePlaceholder(value.shiftStatus)}>
          <TemplateCapableSelect
            value={value.shiftStatus ?? ''}
            onChange={(v) => handleChange(v, 'shiftStatus')}
            isOnTemplatePage={isOnTemplatePage}
            valueAfterRemovePlaceholder="Confirmed"
            templateBuilderDisplayName="Roster filter: Shift status"
          >
            <MenuItem value={'Any'}>Any</MenuItem>
            <MenuItem value={'Confirmed'}>Confirmed</MenuItem>
            <MenuItem value={'Draft'}>Draft</MenuItem>
          </TemplateCapableSelect>
        </FormControl>
      </AccordionField>
    </>
  );
};

export default RosterCriteriaForm;
